export default "__VITE_ASSET__CvqIgTYl__"